<template>
    <div class="modal micromodal-slide" id="offer-exit-pop">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" data-micromodal-close></div>
        <div class="modal popup-offer" tabindex="-1" data-micromodal-close>
            <div class="modal-dialog modal-lg single-offer operator-list !mt-[100px] mx-[8px]" role="document">
                <Transition
                    enter-active-class="transition duration-300 ease-in"
                    enter-class="transform opacity-0 -translate-y-10"
                    enter-to-class="transform opacity-100 translate-y-0"
                >
                    <div
                        class="modal-content"
                    >
                        <div class="modal-body single-offer-item single-offer-operator-item relative">
                            <button type="button" data-dismiss="modal" aria-label="Close"
                                    class="button-close close_popup" data-micromodal-close>
                                <svg viewBox="0 0 384 512" class="close-popup-cta" data-micromodal-close>
                                    <path
                                        d="M231.6 256l130.1-130.1c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L192 216.4 61.9 86.3c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17L152.4 256 22.3 386.1c-4.7 4.7-4.7 12.3 0 17l22.6 22.6c4.7 4.7 12.3 4.7 17 0L192 295.6l130.1 130.1c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17L231.6 256z"
                                        style="color:  black;"></path>
                                </svg>
                            </button>
                            <div class="modal-header-content mb-4">
                                <a class="automation-play-now-cta exit_pop_offer_cta exit-page-link operator-item-link"
                                   rel="nofollow"
                                   target="_blank"
                                   :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                                   :data-gtm="gtm.replace('LOCATION', 'logo')"
                                   data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                   data-ctalocation="image"
                                   :data-operator="offer.brand_name"
                                   :data-product="offer.brand_product_name"
                                   :data-offer="offer.offer_short_description | striptags"
                                   :data-brand_id="offer.brand_id"
                                   :data-brand_product_id="offer.brand_product_id"
                                   :data-offer_id="offer.offer_id"
                                   :data-site_offer_id="offer.site_offer_id"
                                >
                                    <div class="popup-logo">
                                        <img
                                            class="max-w-full h-auto lazyload"
                                            :src="offer.brand_product_image"
                                            :data-src="offer.brand_product_image"
                                            :alt="offer.brand_product_name"
                                            :title="offer.brand_product_name"
                                        >
                                    </div>
                                </a>
                            </div>
                            <div class="popup-2nd-col">
                                <div class="operator-column operator-column-bonus popup-bonus mb-4">
                                    <div class="py-0 md:py-4">
                                        <label v-if="showProductType">{{ offer.product_type }}</label>
                                        <p class="operator-bonus text-center operator-bonus-popup">
                                            <span v-html="offer.offer_short_description"></span>
                                            <span v-if="offer.promo_code"><br>Promo Code:
                                                <em v-html="offer.promo_code"></em></span>
                                        </p>
                                    </div>
                                </div>
                                <div class="operator-column operator-playnow-column p-0"
                                     style="width: 100%; max-width: 300px; display: block; height: auto; float: none; margin: auto">
                                    <a class="automation-play-now-cta exit_pop_offer_cta exit-page-link operator-item-link block"
                                       target="_blank"
                                       :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                                       :data-gtm="gtm.replace('LOCATION', 'logo')"
                                       data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                                       data-ctalocation="cta"
                                       :data-operator="offer.brand_name"
                                       :data-product="offer.brand_product_name"
                                       :data-offer="offer.offer_short_description | striptags"
                                       :data-brand_id="offer.brand_id"
                                       :data-brand_product_id="offer.brand_product_id"
                                       :data-offer_id="offer.offer_id"
                                       :data-site_offer_id="offer.site_offer_id">
                                            <span class="operator-play-now btn-cta-play-now mt-3"
                                                  style="width: 100%">
                                                <span v-if="ctaText">{{ ctaText }}</span>
                                                <span v-else>{{ popupCTAText }}</span>
                                            </span>
                                    </a>
                                </div>
                                <div class="continue-browsing continue_browsing_popup" data-micromodal-close>
                                    Continue Browsing
                                </div>
                            </div>

                            <div class="operator-item-link read-terms-link">
                                <div class="terms-and-conditions" style="padding: 0; margin: 0 15px 15px 15px;">
                                    <div
                                        class="terms-and-conditions"
                                        v-if="offer.offer_terms_conditions"
                                        v-html="offer.offer_terms_conditions"
                                    ></div>
                                    <div class="terms-and-conditions" v-else>
                                            <span v-if="this.ipCountry == 'CA'">
                                                19+. T&C Apply. Play Responsibly
                                            </span>
                                        <span v-else>
                                                <span v-html="getAge()"></span>+, terms apply, 1800-GAMBLER
                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'popup-offer-tw',
    props: {
        id: {
            type: Number,
        },
        offer: {
            type: Object,
            required: true,
        },
        listPosition: {
            type: Number,
            required: false,
            default: 1,
        },
        listId: {
            type: String,
            required: false,
        },
        rankVersion: {
            type: String,
            required: false,
        },
        imgPlaceholder: {
            type: String,
            required: true,
        },
        ct: {
            type: String,
            default: 'cta'
        },
        ctaLocation: {
            type: String,
            required: true,
        },
        ctaText: {
            type: String,
            required: false,
        },
        gtm: {
            type: String,
            required: true,
        },
        selectedState: {
            type: String,
            required: true,
        },
        selectedStateName: {
            type: String,
            default: '',
            required: false,
        },
        isOntario: {
            type: Boolean,
            default: false,
            required: false,
        },
        showProductType: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    data: function () {
        return {
            ctalocation: this.ctaLocation.replaceAll(" ", "_"),
            floatingCTAClosed: false,
            idleMobileTime: 20000, // 20 sec
            idleDesktopTime: 20000,
            timeoutDesktop: false,
            idleTime: 0,
            timeoutID: null,
            intervalID: null,
            popUpCookieName: "",
            showEmail: false,
            showModal: false,
            mutableSelectedState: this.selectedState,
            ipCountry: document.querySelector('html').dataset.ipcountry ?
                document.querySelector('html').dataset.ipcountry.toUpperCase() : false,
            regionCode: document.querySelector('html').dataset.regioncode ?
                document.querySelector('html').dataset.regioncode.toUpperCase() : false,
        }
    },
    methods: {
        getAge() {
            return this.regionCode === 'RI' ? '18' : '21';
        },

        isTouchDevice() {
            return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
        },
        showModalFn() {
            if (!this.floatingCTAClosed) {
                if (!this.showEmail) {
                    MicroModal.show('offer-exit-pop', {
                        disableFocus: true,
                        // targetModal: 'offer-exit-pop',
                        // openClass: 'modal-opened',
                        onClose: modal => {
                            setCookie(this.popUpCookieName, true, 1);
                            this.floatingCTAClosed = true;
                            this.showModal = false;
                        },
                    })
                    this.showModal = true;
                } else {
                    this.$emit('modal-event', {
                        modal: "popUpEmail",
                        show: true,
                    });
                }
                this.floatingCTAClosed = true;
            }
        },

        emailOrOffer() {
            this.floatingCTAClosed = false
            this.popUpCookieName = "offer_closed_us_" + this.offer.brand_product_id + "_" + this.selectedState
            if (getCookie(this.popUpCookieName)) {
                this.floatingCTAClosed = true;
            }

            this.mutableSelectedState = this.selectedState
            this.timeoutDesktop = false;
            setTimeout(() => this.timeoutDesktop = true, this.idleDesktopTime);
            window.clearTimeout(this.timeoutID);
            if (this.isTouchDevice()) {
                this.timeoutID = setTimeout(() => this.showModalFn(), this.idleMobileTime);
            }

            if ((Object.hasOwn(this.offer, 'us_states')) && (this.offer.us_states[0].code === "AB")) {
                this.mutableSelectedState = "AB";
            }

            if (!Object.hasOwn(this.offer, 'us_states') || (this.offer.us_states[0].code != this.mutableSelectedState) || (this.isOntario)) {
                this.showEmail = true;
                if (document.querySelector('#email-form-region-name')) {
                    if (this.isOntario) {
                        document.querySelector('#email-form-region-name').innerHTML = "Ontario";
                    } else {
                        document.querySelector('#email-form-region-name').innerHTML = this.selectedStateName;
                    }
                }
            } else {
                this.showEmail = false;
            }
        },

        resetPopUpTimeout() {
            window.clearTimeout(this.timeoutID);
            this.timeoutID = setTimeout(() => this.showModalFn(), this.idleMobileTime);
        }
    },
    computed: {
        popupCTAText() {
            return window.translations.popupCTA.cta_popup_text || 'VISIT CASINO';
        }
    },

    watch: {
        selectedStateName() {
            if (document.querySelector('#email-form-region-name')) {
                document.querySelector('#email-form-region-name').innerHTML = this.selectedStateName;
            }
        },
        selectedState() {
            return this.emailOrOffer()
        },
        offer() {
            return this.emailOrOffer()
        },
    },

    mounted: function () {
        this.emailOrOffer();

        MicroModal.init({
            targetModal: 'offer-exit-pop',
        });

        document.addEventListener('mouseleave', () => {
            if (this.timeoutDesktop && !this.isTouchDevice()) {
                this.showModalFn();
            }
        });

        document.addEventListener("touchstart", () => {
            if (this.isTouchDevice()) {
                this.resetPopUpTimeout();
            }
        });

        // to catch search input events on mobile
        if (this.isTouchDevice()) {
            this.intervalID = setInterval(() => {
                if (document.getElementsByClassName("search-input")[0]) {
                    document.getElementsByClassName("search-input")[0].addEventListener('input', () => {
                        this.resetPopUpTimeout();
                    })
                }
            }, 3000);
        }

        setTimeout(() => this.timeoutDesktop = true, this.idleDesktopTime);
    }
};


</script>
